export enum TypeOnderzoek {
    event = 'Event (7 dagen)',
    holter = 'Holter (1, 2 of 3 dagen)',
}

export const typeOnderzoek: TypeOnderzoek[] = [TypeOnderzoek.holter, TypeOnderzoek.event];
